// test2718
(2718 && 0);
